import { IHttpRequestOptions } from './../../shared/interfaces/request-options';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { AppConfig } from '../config-models/app-config.model';
import { APP_CONFIG } from '../../../../src/app/config/app-config.module';

@Injectable()
export class NetworkCallService {
  constructor(
    private http: HttpClient,
    private helpers: HelpersService,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {}

  get<Res>(url: string = '', options?: IHttpRequestOptions) {
    return this.http.get<Res>(`${this.appConfig.apiEndpoint}/${decodeURIComponent(url)}`, options).pipe(
      catchError(x => {
        return this.helpers.handleError(x);
      })
    );
  }

  post<Req, Res>(url: string = '', payload?: Req, options?: IHttpRequestOptions) {
    return this.http.post<Res>(`${this.appConfig.apiEndpoint}/${url}`, payload, options).pipe(
      catchError(x => {
        return this.helpers.handleError(x);
      })
    );
  }

  put<Req, Res>(url: string = '', payload?: Req, options?: IHttpRequestOptions) {
    return this.http.put<Res>(`${this.appConfig.apiEndpoint}/${decodeURIComponent(url)}`, payload, options).pipe(
      catchError(x => {
        return this.helpers.handleError(x);
      })
    );
  }

  patch<Req, Res>(url: string = '', payload?: Req, options?: IHttpRequestOptions) {
    return this.http.patch<Res>(`${this.appConfig.apiEndpoint}/${decodeURIComponent(url)}`, payload, options).pipe(
      catchError(x => {
        return this.helpers.handleError(x);
      })
    );
  }

  delete<Req, Res>(url: string = '', options?: IHttpRequestOptions) {
    return this.http.delete<Res>(`${this.appConfig.apiEndpoint}/${decodeURIComponent(url)}`, options).pipe(
      catchError(x => {
        return this.helpers.handleError(x);
      })
    );
  }
}
